import { render, staticRenderFns } from "./TotalPriceData.vue?vue&type=template&id=0ebc5055"
import script from "./TotalPriceData.vue?vue&type=script&lang=ts"
export * from "./TotalPriceData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports